import React, { Component } from "react";
import "./App.css";
import { HashRouter, Route, Switch } from "react-router-dom";
import LoginForm from "./containers/LoginForm";
import EnterSitePage from "./containers/EnterSitePage";
import MainPage from "./containers/MainPage";
import ExpiredPage from "./containers/ExpiredPage";
import SsoPage from "./containers/SsoPage";
import LoginSupportForm from "./containers/LoginSupportForm";
import PingSsoPage from "./containers/PingSsoPage";
import StaticLogoutPage from "./containers/StaticLogoutPage";

import ThemeMainPage from "./theme/ThemeMainPage";

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact={true} path="/" component={LoginForm} />
          <Route exact={true} path="/sso" component={SsoPage} />
          <Route exact={true} path="/expired" component={ExpiredPage} />
          <Route exact={true} path="/enter" component={EnterSitePage} />
          <Route exact={true} path="/main" component={MainPage} />
          <Route exact={true} path="/thememain" component={ThemeMainPage} />
          <Route exact={true} path="/support" component={LoginSupportForm} />
          <Route exact={true} path="/pingsso" component={PingSsoPage} />
          <Route
            exact={true}
            path="/staticlogout"
            component={StaticLogoutPage}
          />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
